import { render } from "./App.vue?vue&type=template&id=8102dbf6&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8102dbf6&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8102dbf6"]])

export default __exports__